import apiConfig from "constants/apiConfig"
import axiosClient from "utils/axiosClient"

export const initIGConnection = async (agencyId: string) => {
    const response = await axiosClient.get(apiConfig.INIT_IG_CONNECTION.url.replace('<agencyId>', agencyId));
    return response.data;
}

export const submitAccessToken = async (agencyId: string, access_token: string) => {
    const response = await axiosClient.post(apiConfig.SUBMIT_ACCESS_TOKEN_FOR_IG_CONNECT.url.replace('<agencyId>', agencyId), {access_token});
    return response.data;
}  

export const fetchConnectedIGAccounts = async (agencyId: string) => {
    const response = await axiosClient.get(apiConfig.LIST_CONNECTED_IG_ACCOUNTS.url.replace('<agencyId>', agencyId));
    return response.data;
}

export const linkIGAccount = async (agencyId: string, igAccountId: string, via: string = 'fb') => {
    const response = await axiosClient.get(apiConfig.LINK_IG_ACCOUNT.url.replace('<agencyId>', agencyId).replace('<accountId>', igAccountId));
    return response.data;
}

export const fetchSocialAccounts = async (agencyId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_SOCIAL_ACCOUNTS.url.replace('<agencyId>', agencyId));
    return response.data;
}

export const fetchSocialAccount = async (agencyId: string, socialAccountId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_SOCIAL_ACCOUNT.url.replace('<agencyId>', agencyId).replace('<socialAccountId>', socialAccountId));

    return response.data;
}

export const fetchSocialPostComments = async (agencyId: string, socialAccountId: string, socialPostId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_SOCIAL_POST_COMMENTS.url.replace('<agencyId>', agencyId).replace('<socialAccountId>', socialAccountId).replace('<socialPostId>', socialPostId));
    return response.data.items ?? [];
}

export const deleteSocialPostComment = async (agencyId: string, socialAccountId: string, socialPostId: string, commentId: string) => {
    const response = await axiosClient.delete(apiConfig.DELETE_SOCIAL_POST_COMMENTS.url.replace('<agencyId>', agencyId).replace('<socialAccountId>', socialAccountId).replace('<socialPostId>', socialPostId).replace('<commentId>', commentId));
    return response.data;
}

export const replySocialPostComment = async (agencyId: string, socialAccountId: string, socialPostId: string, commentId: string, message: string) => {
    const response = await axiosClient.post(apiConfig.REPLY_SOCIAL_POST_COMMENT.url.replace('<agencyId>', agencyId).replace('<socialAccountId>', socialAccountId).replace('<socialPostId>', socialPostId).replace('<commentId>', commentId), {message});
    return response.data;
}

export const replyPrivatelySocialPostComment = async (agencyId: string, socialAccountId: string, socialPostId: string, commentId: string, message: string) => {
    const response = await axiosClient.post(apiConfig.REPLY_PRIVATELY_SOCIAL_POST_COMMENT.url.replace('<agencyId>', agencyId).replace('<socialAccountId>', socialAccountId).replace('<socialPostId>', socialPostId).replace('<commentId>', commentId), {message});
    return response.data;
}